import _get from 'lodash/get';
import { v4 as uuidv4 } from 'uuid';

/**
 * @param {import('zod').infer<typeof import("./stubs").FORM_SCHEMA>} data
 * */
export function createPayload(data = {}) {
  return {
    // static info
    is_enabled: true,
    allows_return: true,
    allows_exchange: true,
    exchange_info: {
      all_variant: { enabled: true },
      product_catalog: { enabled: true },
      show_recommendations: { enabled: false }
    },
    recommendation_id: null,
    media_required: false,
    allows_keep_item: false,
    qualification_approval_needed: false,
    products: [],
    product_types: [],
    product_categories: [],

    // dynamic info
    ...data,
    identifier: `${_get(data, 'name', '')}-${uuidv4()}`
  };
}
